export const TYPES = {
  SET_DRAFT_BAILIFF_ALL: "draft_bailiff/SET_DRAFT_BAILIFF_ALL",
  SET_DRAFT_BAILIFF_OPEN_ADD: "draft_bailiff/SET_DRAFT_BAILIFF_OPEN_ADD",
  SET_DRAFT_BAILIFF_OPEN_EDIT: "draft_bailiff/SET_DRAFT_BAILIFF_OPEN_EDIT",
  SET_DRAFT_BAILIFF_SELECTED: "draft_bailiff/SET_DRAFT_BAILIFF_SELECTED",
  SET_DRAFT_BAILIFF_SEARCH: "draft_bailiff/SET_DRAFT_BAILIFF_SEARCH",
  //
  SET_DRAFT_BAILIFF_DETAIL: "draft_bailiff/SET_DRAFT_BAILIFF_DETAIL",
  SET_DRAFT_BAILIFF_OPEN_FORWARD:
    "draft_bailiff/SET_DRAFT_BAILIFF_OPEN_FORWARD",
  SET_DRAFT_BAILIFF_MERGE: "draft_bailiff/SET_DRAFT_BAILIFF_MERGE",
  SET_DRAFT_BAILIFF_SPEAKERS: "draft_bailiff/SET_DRAFT_BAILIFF_SPEAKERS",
};
